import React, { useState } from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../components/Form';
import Button from '../../components/Button/Button';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../components/FilterBar/FilterBar';
import { rebassProps } from '../../theme/theme';
import { TesterStatusPicker } from '../../components/Tester/TesterStatusPicker';
import { ProfileTypePicker } from '../../components/Tester/ProfileTypePicker';
import {
  getStringSearchOr,
  getStringSearchPlaceholder,
} from '../../helpers/search';

const stringSearchFields = [
  {
    field: 'profile.name',
    label: 'Name',
  },
  {
    field: 'accountNumber',
    label: 'Account',
  },
  {
    field: 'profile.phones.value',
    label: 'Phone',
  },
  {
    field: 'profile.emails.value',
    label: 'Email',
  },
];

type FilterBarTesterProps = FilterBarProps<Record<string, any>>;

const FilterBarTester: React.FC<FilterBarTesterProps> = (props) => {
  const { filters = {}, setFilters, selectedId } = props;
  const [stringSearch, setStringSearch] = useState<string>('');

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(stringSearchFields)}
          autoFocus={isBrowser && !selectedId}
          width={275}
          value={stringSearch}
          onChange={(event) => {
            setStringSearch(event.target.value);
            if (setFilters) {
              setFilters({
                ...filters,
                or: getStringSearchOr(stringSearchFields, event.target.value),
              });
            }
          }}
        />
        <TesterStatusPicker
          value={filters.status}
          isClearable={true}
          onChange={(value) => {
            setFilters({
              ...filters,
              status: value,
            });
          }}
        />
        <ProfileTypePicker
          value={filters['profile.type']}
          isClearable={true}
          onChange={(value) => {
            setFilters({
              ...filters,
              'profile.type': value,
            });
          }}
        />
      </Flex>

      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => {
            if (setFilters) {
              setFilters({
                status: 1,
              });
              setStringSearch('');
            }
          }}
          title="Reset Form"
        />
      </Flex>
    </Flex>
  );
};

FilterBarTester.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarTester;
